// extracted by mini-css-extract-plugin
export var whocontact = "technology-module--whocontact--zm0Ht";
export var who = "technology-module--who--3P4w5";